import * as React from "react";

import { Root } from "./Strong.styles";

interface StrongProps {
    children: React.ReactNode;
}

export function Strong(props: StrongProps): JSX.Element {
    return <Root>{props.children}</Root>;
}
